import { render, staticRenderFns } from "./Arrivi.vue?vue&type=template&id=296f9108"
import script from "./Arrivi.vue?vue&type=script&lang=js"
export * from "./Arrivi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports